document.addEventListener("DOMContentLoaded", function () {

  window.addEventListener("scroll", function () {

    document.querySelectorAll('.fadein').forEach(function (element) {
      const position = element.getBoundingClientRect().top + window.pageYOffset;
      const scroll = window.pageYOffset;
      const windowHeight = window.innerHeight;

      if (scroll > position - windowHeight + 50) {
        element.classList.add('active');
      }
    });

  });

});

document.addEventListener('DOMContentLoaded', function () {
	const swiper01 = new Swiper('.novelty  .swiper', {
		loop: true,
		speed: 1500,
		slidesPerView: 1,
		centeredSlides: false,
		effect: 'fade',
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
	});
});
